import { post } from "../../helpers/utils/http-client";
import { APPS_ENDPOINT } from '../../consts/api-endpoints';

export async function saveLLMSettings(appId, data) {
    return await post(`${APPS_ENDPOINT}/${appId}/llm`, data);
}

export async function validateLLMApiKey(appId, apiKey) {
    return await post(`${APPS_ENDPOINT}/${appId}/llm/validate`, { apiKey });
}